(() => {
  const criticalHealth = new Set(['kidney','liver','pancreas','diabetes','heart','pregnant','other']);
  const labels = {digestion:'Verdauung',skin:'Haut & Fell',joints:'Gelenke',weight:'Gewicht',urinary:'Harnwege'};

  document.querySelectorAll('[id^="BarfegoQuiz-"]').forEach(initQuiz);

  function initQuiz(root){
    const form = root.querySelector('[data-form]');
    if(!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const steps = [...form.querySelectorAll('[data-step]')];
    const inputSteps = steps.filter(step => step.dataset.step !== 'result');
    const resultStep = form.querySelector('[data-step="result"]');
    const back = form.querySelector('[data-back]');
    const next = form.querySelector('[data-next]');
    const error = form.querySelector('[data-error]');
    const progress = root.querySelector('[data-progress]');
    const progressText = root.querySelector('[data-progress-text]');
    const catalog = root.querySelector('[data-catalog]');
    let index = 0;
    let showingResult = false;

    function value(name){ return form.elements[name]?.value || ''; }
    function checked(name){ return [...form.querySelectorAll(`input[name="${name}"]:checked`)].map(el => el.value); }
    function esc(text){ const div=document.createElement('div'); div.textContent=String(text); return div.innerHTML; }

    function syncLifeStages(){
      const select = form.querySelector('[data-life-stage]');
      const animal = value('animal');
      const current = select.value;
      const options = animal === 'cat'
        ? [['','Bitte wählen'],['kitten','Kitten (bis 12 Monate)'],['adult','Erwachsen'],['senior','Senior (ab ca. 10 Jahren)']]
        : [['','Bitte wählen'],['puppy-young','Welpe (bis 5 Monate)'],['puppy','Junghund (6–12 Monate)'],['adult','Erwachsen'],['senior','Senior']];
      select.innerHTML = options.map(([v,t]) => `<option value="${v}">${t}</option>`).join('');
      if(options.some(([v]) => v === current)) select.value = current;
    }

    function showStep(){
      showingResult = false;
      steps.forEach(step => step.hidden = true);
      inputSteps[index].hidden = false;
      back.hidden = index === 0;
      next.hidden = false;
      next.textContent = index === inputSteps.length - 1 ? 'Empfehlung anzeigen' : 'Weiter';
      error.textContent = '';
      const pct = ((index + 1) / inputSteps.length) * 100;
      progress.style.width = `${pct}%`;
      progressText.textContent = `Schritt ${index + 1} von ${inputSteps.length}`;
      if(inputSteps[index].dataset.step === 'profile') syncLifeStages();
      inputSteps[index].querySelector('input,select')?.focus({preventScroll:true});
    }

    function validate(){
      const fields = [...inputSteps[index].querySelectorAll('input[required],select[required]')];
      const radioNames = [...new Set(fields.filter(f=>f.type==='radio').map(f=>f.name))];
      if(radioNames.some(name => !form.querySelector(`input[name="${name}"]:checked`))) return false;
      return fields.filter(f=>f.type!=='radio').every(f => f.checkValidity());
    }

    next.addEventListener('click', () => {
      if(!validate()){
        error.textContent = 'Bitte fülle die erforderlichen Angaben aus.';
        inputSteps[index].querySelector(':invalid')?.focus();
        return;
      }
      if(index < inputSteps.length - 1){ index++; showStep(); }
      else renderResult();
    });
    back.addEventListener('click', () => {
      if(showingResult){ index = inputSteps.length - 1; showStep(); return; }
      if(index > 0){ index--; showStep(); }
    });
    form.addEventListener('change', event => { if(event.target.name === 'animal') syncLifeStages(); error.textContent=''; });

    function calculate(){
      const animal = value('animal');
      const stage = value('life_stage');
      const weight = Math.max(.5, parseFloat(value('weight').replace(',','.')) || 1);
      const dogRates = {'puppy-young':.07,puppy:.05,adult:.025,senior:.022};
      const catRates = {kitten:.06,adult:.03,senior:.025};
      let rate = animal === 'cat' ? catRates[stage] : dogRates[stage];
      const bodyFactor = {under:1.1,ideal:1,over:.9,obese:.8}[value('body')] || 1;
      const activityFactor = {low:.9,normal:1,high:1.12}[value('activity')] || 1;
      const goalFactor = {lose:.9,maintain:1,gain:1.1}[value('goal')] || 1;
      const neuterFactor = value('neutered') === 'yes' ? .95 : 1;
      rate *= bodyFactor * activityFactor * goalFactor * neuterFactor;
      if(animal === 'dog' && stage === 'adult') rate = Math.min(.05,Math.max(.015,rate));
      if(animal === 'cat' && stage !== 'kitten') rate = Math.min(.045,Math.max(.02,rate));
      const grams = Math.max(20,Math.round(weight * 1000 * rate / 10) * 10);
      return {animal,stage,weight,grams,days:Number(value('days')) || 28};
    }

    function productData(el){
      return {
        el,
        kind:el.dataset.kind,
        species:el.dataset.species,
        proteins:(el.dataset.proteins||'').split(',').filter(Boolean),
        concerns:(el.dataset.concerns||'').split(',').filter(Boolean),
        pack:Number(el.dataset.packGrams)||0,
        variantId:Number(el.dataset.variantId),
        available:el.dataset.available==='true'
      };
    }

    function kindLabel(kind){
      return {menu:'Hauptfutter',component:'BARF-Komponente',supplement:'Ergänzung',snack:'Snack & Kauartikel'}[kind] || 'Empfehlung';
    }

    function money(cents){
      return new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100);
    }

    async function loadStoreProduct(item){
      try{
        const base=window.Shopify?.routes?.root||'/';
        const response=await fetch(`${base}products/${encodeURIComponent(item.handle)}.js`,{headers:{Accept:'application/json'}});
        if(!response.ok) return null;
        const product=await response.json();
        const variant=(product.variants||[]).find(v=>v.available)||product.variants?.[0];
        if(!variant||!variant.available) return null;
        return {item,product,variant};
      }catch(e){ return null; }
    }

    function dynamicCard(loaded,calc,name,isFirstMenu){
      const {item,product,variant}=loaded;
      const card=document.createElement('article');
      card.className='bfq__product';
      card.dataset.product='';
      card.dataset.kind=item.kind;
      card.dataset.proteins=(item.proteins||[]).join(',');
      card.dataset.concerns=(item.needs||[]).join(',');
      card.dataset.packGrams=item.pack||0;
      card.dataset.variantId=variant.id;
      card.dataset.available='true';
      card.dataset.handle=item.handle;
      const quantity=item.kind==='menu'&&item.pack?Math.max(1,Math.ceil(calc.grams*calc.days/item.pack)):1;
      const checked=item.kind==='menu'?isFirstMenu:item.kind==='supplement';
      const image=product.featured_image||product.images?.[0]||'';
      card.innerHTML=`<label class="bfq__product-select"><input type="checkbox" data-product-check ${checked?'checked':''}><span>Auswählen</span></label><a href="${esc(product.url||'/products/'+item.handle)}" class="bfq__product-image" target="_blank">${image?`<img src="${esc(image)}" loading="lazy" alt="${esc(product.title)}">`:''}</a><div class="bfq__product-body"><p class="bfq__product-type">${kindLabel(item.kind)}</p><h3><a href="${esc(product.url||'/products/'+item.handle)}" target="_blank">${esc(product.title)}</a></h3><p>${money(variant.price)}${item.pack?` · ${item.pack} g`:''}</p><label class="bfq__quantity">Menge <input type="number" min="0" max="99" value="${quantity}" data-quantity aria-label="Menge ${esc(product.title)}"></label></div>`;
      return card;
    }

    async function renderResult(){
      showingResult = true;
      const calc = calculate();
      const name = value('pet_name').trim() || (calc.animal==='cat'?'deine Katze':'dein Hund');
      const allergies = new Set(checked('allergies'));
      const health = checked('health');
      const hasCritical = health.some(item => criticalHealth.has(item));
      steps.forEach(step => step.hidden = true);
      resultStep.hidden = false;
      back.hidden = false;
      next.hidden = true;
      error.textContent='';
      progress.style.width='100%';
      progressText.textContent='Deine Empfehlung';
      const result = resultStep.querySelector('[data-result]');

      if(hasCritical){
        const url=root.dataset.consultationUrl;
        result.innerHTML=`<div class="bfq__result-head"><h2>${esc(name)} braucht eine individuelle Empfehlung</h2><p>Bei den ausgewählten gesundheitlichen Angaben wäre eine automatische Produktempfehlung nicht verantwortungsvoll.</p></div><div class="bfq__warning"><h3>Bitte erst fachlich abklären</h3><p>Bei diagnostizierten Erkrankungen, Trächtigkeit oder Laktation können Energie- und Nährstoffbedarf deutlich abweichen. Lass die Ration bitte tierärztlich oder durch eine qualifizierte Ernährungsberatung prüfen.</p><a class="bfq__button" href="${esc(url)}">Beratung anfragen</a></div>`;
        return;
      }

      const meals = (calc.stage==='kitten'||calc.stage==='puppy-young') ? '3–4' : (calc.weight<10 ? '2–3' : '2');
      const automaticNeeds=[...health];
      if(['senior'].includes(calc.stage)) automaticNeeds.push('senior');
      if(['kitten','puppy','puppy-young'].includes(calc.stage)) automaticNeeds.push('puppy');
      if(value('activity')==='high') automaticNeeds.push('active');
      const selectedNeeds = health.filter(h=>labels[h]).map(h=>labels[h]);
      result.innerHTML=`<div class="bfq__result-head"><h2>Unsere Empfehlung für ${esc(name)}</h2><p>Orientierungswert für ein gesundes Tier. Beobachte Gewicht und Körperform und passe die Menge bei Bedarf schrittweise an.</p></div><div class="bfq__kpis"><div class="bfq__kpi"><b>${calc.grams} g</b><span>pro Tag</span></div><div class="bfq__kpi"><b>${calc.grams*7} g</b><span>pro Woche</span></div><div class="bfq__kpi"><b>${meals}</b><span>Mahlzeiten pro Tag</span></div></div>${selectedNeeds.length?`<p class="bfq__help">Berücksichtigt: ${selectedNeeds.map(esc).join(', ')}</p>`:''}<div class="bfq__recommendations"><h2>Passende BARFeGO-Produkte</h2><p class="bfq__help" data-loading-products>Passende und verfügbare Produkte werden geladen …</p><div class="bfq__product-grid" data-product-grid></div><div class="bfq__more-wrap" data-more-wrap hidden><button type="button" class="bfq__button bfq__button--ghost" data-more>Weitere passende Produkte anzeigen</button></div><div class="bfq__cart-row"><p class="bfq__cart-note">Die Packungsanzahl basiert auf ${calc.days} Tagen und wird auf volle Packungen aufgerundet. Wähle ein Hauptfutter sowie gewünschte Komponenten, Ergänzungen oder Snacks.</p><button type="button" class="bfq__button" data-add-cart>Auswahl in den Warenkorb</button></div></div>`;

      const grid=result.querySelector('[data-product-grid]');
      const editorProducts=[...document.querySelectorAll('[data-bfq-catalog][data-catalog-version="6"] [data-product]')];
      const legacyProducts=[...catalog.querySelectorAll('[data-product]')];
      const products=(editorProducts.length?editorProducts:legacyProducts).map(productData);
      const manualHandles=new Set(products.map(p=>p.el.dataset.handle).filter(Boolean));
      const manifest=(window.BARFEGO_QUIZ_PRODUCTS||[]).filter(p=>!manualHandles.has(p.handle));
      const matches=p=>(p.species===calc.animal||p.species==='both')&&!p.proteins.some(protein=>allergies.has(protein))&&!(allergies.size&&['menu','snack'].includes(p.kind)&&!p.proteins.length)&&(p.kind!=='supplement'||!p.needs.length||p.needs.some(c=>automaticNeeds.includes(c)));
      const kindOrder={menu:0,component:1,supplement:2,snack:3};
      const candidates=manifest.filter(matches).sort((a,b)=>{
        const ar=a.needs.some(n=>automaticNeeds.includes(n))?0:1;
        const br=b.needs.some(n=>automaticNeeds.includes(n))?0:1;
        return ar-br||(kindOrder[a.kind]??9)-(kindOrder[b.kind]??9)||a.title.localeCompare(b.title,'de');
      });
      const eligible=products.filter(p=>p.available&&(p.species===calc.animal||p.species==='both')&&!p.proteins.some(protein=>allergies.has(protein))&&!(allergies.size&&['menu','snack'].includes(p.kind)&&!p.proteins.length)&&(p.kind!=='supplement'||!p.concerns.length||p.concerns.some(c=>automaticNeeds.includes(c)))).sort((a,b)=>{
        const ar=a.concerns.some(n=>automaticNeeds.includes(n))?0:1;
        const br=b.concerns.some(n=>automaticNeeds.includes(n))?0:1;
        return ar-br||(kindOrder[a.kind]??9)-(kindOrder[b.kind]??9);
      });
      let menuSelected=false;
      function appendEditorProduct(p){
        const card=p.el.cloneNode(true);
        card.hidden=false;
        const check=card.querySelector('[data-product-check]');
        const qty=card.querySelector('[data-quantity]');
        check.checked=p.kind==='menu'&&!menuSelected;
        if(check.checked) menuSelected=true;
        qty.value=p.kind==='menu'&&p.pack?Math.max(1,Math.ceil(calc.grams*calc.days/p.pack)):1;
        grid.appendChild(card);
      }
      let staticCursor=0;
      let cursor=0;
      const moreWrap=result.querySelector('[data-more-wrap]');
      const more=result.querySelector('[data-more]');
      const loading=result.querySelector('[data-loading-products]');
      async function appendBatch(){
        more.disabled=true;
        const editorBatch=eligible.slice(staticCursor,staticCursor+12);
        staticCursor+=editorBatch.length;
        editorBatch.forEach(appendEditorProduct);
        const remaining=Math.max(0,12-editorBatch.length);
        const batch=candidates.slice(cursor,cursor+remaining);
        cursor+=batch.length;
        const loaded=(await Promise.all(batch.map(loadStoreProduct))).filter(Boolean);
        loaded.forEach(entry=>{
          const firstMenu=entry.item.kind==='menu'&&!menuSelected;
          if(firstMenu) menuSelected=true;
          grid.appendChild(dynamicCard(entry,calc,name,firstMenu));
        });
        loading.hidden=true;
        moreWrap.hidden=staticCursor>=eligible.length&&cursor>=candidates.length;
        more.disabled=false;
        if(!grid.children.length&&staticCursor>=eligible.length&&cursor>=candidates.length){
          grid.innerHTML='<p class="bfq__empty">Für diese Kombination gibt es aktuell kein automatisch passendes und verfügbares Produkt. Bitte nutze unsere Beratung.</p>';
          result.querySelector('[data-add-cart]').hidden=true;
        }
      }
      await appendBatch();
      more.addEventListener('click',appendBatch);
      grid.addEventListener('change', event=>{
        if(event.target.matches('[data-product-check]')){
          const card=event.target.closest('[data-product]');
          if(card.dataset.kind==='menu'&&event.target.checked){
            grid.querySelectorAll('[data-product][data-kind="menu"] [data-product-check]').forEach(cb=>{if(cb!==event.target)cb.checked=false;});
          }
        }
      });
      result.querySelector('[data-add-cart]').addEventListener('click', addToCart);
    }

    async function addToCart(event){
      const button=event.currentTarget;
      const items=[...resultStep.querySelectorAll('[data-product]')].filter(card=>card.querySelector('[data-product-check]').checked).map(card=>({id:Number(card.dataset.variantId),quantity:Math.max(1,Number(card.querySelector('[data-quantity]').value)||1),properties:{'Empfehlung':'BARFeGO BARF Quiz','Tier':value('pet_name').trim()}}));
      if(!items.length){error.textContent='Bitte wähle mindestens ein Produkt aus.';return;}
      button.disabled=true;button.textContent='Wird hinzugefügt …';
      try{
        const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok) throw new Error('cart');
        window.location.href=`${window.Shopify?.routes?.root||'/'}cart`;
      }catch(e){error.textContent='Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.';button.disabled=false;button.textContent='Auswahl in den Warenkorb';}
    }

    showStep();
  }
})();
